import { render, staticRenderFns } from "./news3.vue?vue&type=template&id=0a959ef7&scoped=true"
import script from "./news3.vue?vue&type=script&lang=js"
export * from "./news3.vue?vue&type=script&lang=js"
import style0 from "./news3.vue?vue&type=style&index=0&id=0a959ef7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a959ef7",
  null
  
)

export default component.exports